import { JwtHelperService } from '@auth0/angular-jwt';
import { User, USER_INIT_STATE } from "./models/user.model";
import { CookieService } from './services/cookie.service';
import { inject } from '@angular/core';
import { JWT_OPTIONS } from '@auth0/angular-jwt';

export function isTokenExpired(): boolean {
  const cookieService = inject(CookieService);
  const jwtHelper = inject(JwtHelperService);
  const token = cookieService.getCookie('jwt');

  if (!token) {
    return true;
  }

  return jwtHelper.isTokenExpired(token);
}

export const ADMIN_ROLE = 1;

export function isAdminUser(role: string | number | undefined | null): boolean {
  return Number(role) === ADMIN_ROLE;
}

export function isAdmin(): boolean {
  return isAdminUser(getUserFromToken().role);
}

export function getUserFromToken(): User {
  const cookieService = inject(CookieService);
  const jwtHelper = inject(JwtHelperService);
  const token = cookieService.getCookie('jwt');
  let user: User = USER_INIT_STATE;

  if (token) {
    const decodedToken = jwtHelper.decodeToken(token);
    user = {
      ...user,
      ...decodedToken,
      username: decodedToken.login || decodedToken.username || '',
    };
  }

  return user;
}

export function getUsernameFromJwt(): string {
  const user: User = getUserFromToken();
  return user && user.login ? user.login : '';
}

export function tokenGetter() {
  const cookieService = inject(CookieService);
  return cookieService.getCookie('jwt');
}

export const jwtProviders = [{
  provide: JWT_OPTIONS,
  useValue: {
    tokenGetter: tokenGetter,
  }
},
  JwtHelperService
];

export function jwtOptionsFactory(cookieService: CookieService) {
  return {
    tokenGetter: () => cookieService.getCookie('jwt'),
  };
}
